import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ContextProvider } from "context/context";
import { PusherProvider } from "context/pusher";
import { LanguageProvider } from "context/language";
import { SubscriptionProvider } from "context/subscription";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import localstorageService from "services/local-storage";
import httpService from "services/https";
import validationService from "services/validation";

import store from "redux/index";
import "react-loading-skeleton/dist/skeleton.css";
import "./index.css";
import "./utils/i18next";
import * as Sentry from "@sentry/react";
import { VideoPlayerProvider } from "context/videoPlayerContext";

Sentry.init({
  dsn: "https://03d30895e86a1e8fd495a2b4c30981c8@o4509206635544576.ingest.us.sentry.io/4509206637117440",
  environment: process.env.REACT_APP_ENV || 'local',
});

global.services = {
  http: httpService,
  localstorage: localstorageService,
  validation: validationService,
};

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ContextProvider>
    <Provider store={store}>
      <SubscriptionProvider>
        <PusherProvider>
        <VideoPlayerProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </VideoPlayerProvider>
        </PusherProvider>
      </SubscriptionProvider>
    </Provider>
  </ContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
